export default __webpack_public_path__ + "static/media/videoProduct.082de503.mp4";